/// <reference path="../wpt.ts" />
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var WPTNamespace;
(function (WPTNamespace) {
    var Widgets;
    (function (Widgets) {
        const LOG_CATEGORY = "WPT.Widgets.ActionPalette";
        class ActionPaletteWidgetTypeClass extends Widgets.WidgetTypeBaseClass {
            constructor(core, widgets, widgetName, config, layout, readyCallback = null) {
                super(core, widgets, widgetName, config, layout, readyCallback);
                this.createInstance = (config) => {
                    this._log.info("ActionPaletteWidgetTypeClass.createInstance()");
                    return new ActionPaletteInstanceClass(this._core, this, this._widgets, config, this._originatingLayout);
                };
                this._storeStandardHtml = (htmlData) => {
                    this._log.info("ActionPaletteWidgetTypeClass._storeStandardHtml()");
                    ActionPaletteInstanceClass.HtmlData = htmlData;
                    this._presentInstances();
                };
                this._log = this._core.Logging.getLogger(LOG_CATEGORY);
                this._log.info("ActionPaletteWidgetTypeClass::constructor");
                if (ActionPaletteInstanceClass.HtmlData != null) {
                    // make async call in order to get the instances created first
                    window.setTimeout(this._presentInstances, 0);
                }
                else {
                    core.Loader.getVersionedHTML('widgets/ActionPalette/action-palette.html', this._storeStandardHtml, this._core.Helper.missingHtmlErrorCallback);
                }
            }
        }
        Widgets.ActionPaletteWidgetTypeClass = ActionPaletteWidgetTypeClass;
        class ActionPaletteInstanceClass extends Widgets.WidgetInstanceBaseClass {
            constructor(core, type, widgets, config, layout) {
                super(core, type, widgets, config, layout);
                this._instanceSelector = null;
                this._outerDiv = null;
                this._typedConfig = null;
                this._loader = null;
                this._bpcContainer = null;
                this._bpcComponent = null;
                this._bpcConfig = {};
                this._cloakIfNoActions = false;
                this._busyModalSession = null;
                this._viewConfigFile = null;
                // State
                this._currentComment = "";
                this._currentDocument = null;
                this._currentQueue = null;
                this._currentWvObject = null;
                this._currentAHT = null;
                this._currentPST = null;
                this._currentWVA = null;
                this._reactToDocSlots = [];
                this._lastReactedDocSlots = [];
                this._reactToWvObjSlots = [];
                this._lastReactedWvObjSlots = [];
                this._showBusyModal = true;
                this._clearOnNonResponderDoc = false;
                this._query = null;
                this._flexQuery = null;
                this._refreshTriggers = null;
                this._queuesLoaded = false;
                this._psTasksLoaded = false;
                // Store local copies as we may modify them in action
                this._overrides = [];
                this.presentInstance = () => {
                    this._log.info("ActionPaletteInstanceClass.presentInstance()");
                    this._container.innerHTML = ActionPaletteInstanceClass.HtmlData;
                    this._prepareErrorBanner();
                    this._outerDiv = this._container.querySelector('div.widget');
                    this._loader = this._container.querySelector('.wpt-hourglass');
                    this._bpcContainer = this._container.querySelector('#actionPaletteHolder');
                    this._core.Helper.prepareHourglassIcon(this._loader);
                    this._widgets.setTitle(this._config, this._container.querySelector('#actionPaletteWidgetTitle'), 'STR_WPT_ACTIONS');
                    this._widgets.setCollapseState(this._config, this._instanceSelector);
                    this._widgets.addCollapseEventListener(this);
                    this._widgets.setWidgetHeight(this._config, this._container);
                    this._widgets.setSuppressBorder(this._config, this._container);
                    this._widgets.setSuppressHeading(this._config, this._container);
                    // Translations
                    this._core.Helper.setElementTranslation(this._container.querySelector('#actionPaletteLoading'), 'STR_WPT_LOADING');
                    // Exception lists and overrides should be zeroed if not defined
                    if (this._typedConfig.hasOwnProperty("RespondToDocSlots") && (this._typedConfig.RespondToDocSlots != null))
                        this._reactToDocSlots = this._typedConfig.RespondToDocSlots;
                    else
                        this._reactToDocSlots = [];
                    if (this._typedConfig.hasOwnProperty("RespondToPrimaryDoc") && this._typedConfig.RespondToPrimaryDoc)
                        this._reactToDocSlots.push(WPTNamespace.Utilities.PRIMARY_SLOT_KEY);
                    if (this._typedConfig.hasOwnProperty("RespondToRelatedDoc") && this._typedConfig.RespondToRelatedDoc)
                        this._reactToDocSlots.push(WPTNamespace.Utilities.RELATED_SLOT_KEY);
                    // Emergency default
                    if (this._reactToDocSlots.length == 0)
                        this._reactToDocSlots.push(WPTNamespace.Utilities.PRIMARY_SLOT_KEY);
                    // WorkView slots
                    if (this._typedConfig.hasOwnProperty("RespondToWvObjSlots") && (this._typedConfig.RespondToWvObjSlots != null))
                        this._reactToWvObjSlots = this._typedConfig.RespondToWvObjSlots;
                    else
                        this._reactToWvObjSlots = [WPTNamespace.Utilities.PRIMARY_SLOT_KEY];
                    if (this._typedConfig.hasOwnProperty("CloakIfNoActions") && (this._typedConfig.CloakIfNoActions != null))
                        this._cloakIfNoActions = this._typedConfig.CloakIfNoActions;
                    if (this._typedConfig.hasOwnProperty("ShowBusyModal") && (this._typedConfig.ShowBusyModal != null))
                        this._showBusyModal = this._typedConfig.ShowBusyModal;
                    if (this._typedConfig.hasOwnProperty("ClearOnNonRespondingDoc") && (this._typedConfig.ClearOnNonRespondingDoc != null))
                        this._clearOnNonResponderDoc = this._typedConfig.ClearOnNonRespondingDoc;
                    if (this._typedConfig.hasOwnProperty("Query") && (this._typedConfig.Query != null))
                        this._query = this._typedConfig.Query;
                    if (this._typedConfig.hasOwnProperty("FlexQuery") && (this._typedConfig.FlexQuery != null))
                        this._flexQuery = this._typedConfig.FlexQuery;
                    if (this._typedConfig.hasOwnProperty("LayoutOptions") && this._typedConfig.LayoutOptions)
                        this._bpcConfig = this._typedConfig.LayoutOptions;
                    if (!this._typedConfig.hasOwnProperty('ExceptAdHocTasks') || !this._typedConfig.ExceptAdHocTasks)
                        this._typedConfig.ExceptAdHocTasks = [];
                    if (!this._typedConfig.hasOwnProperty('ExceptDocActions') || !this._typedConfig.ExceptDocActions)
                        this._typedConfig.ExceptDocActions = [];
                    if (!this._typedConfig.hasOwnProperty('ExceptPseudoSystemTasks') || !this._typedConfig.ExceptPseudoSystemTasks)
                        this._typedConfig.ExceptPseudoSystemTasks = [];
                    if (!this._typedConfig.hasOwnProperty('ExceptWVActions') || !this._typedConfig.ExceptWVActions)
                        this._typedConfig.ExceptWVActions = [];
                    if (!this._typedConfig.hasOwnProperty('TaskOverrides') || !this._typedConfig.TaskOverrides)
                        this._typedConfig.TaskOverrides = [];
                    if (this._typedConfig.hasOwnProperty('RefreshTriggers') && this._typedConfig.RefreshTriggers && (this._typedConfig.RefreshTriggers.length > 0))
                        this._refreshTriggers = this._typedConfig.RefreshTriggers;
                    else
                        this._refreshTriggers = [];
                    this._zeroTriggers();
                    if (!this._bpcConfig.hasOwnProperty("NoItemsLabelText") || !this._bpcConfig.NoItemsLabelText)
                        this._bpcConfig.NoItemsLabelText = 'STR_WPT_NO_ACTIONS_AVAILABLE';
                    if (!this._bpcConfig.hasOwnProperty('UsePrimaryColour')) {
                        let usePrimary = false;
                        if (this._config.hasOwnProperty('SuppressHeading') && this._config.SuppressHeading === true) {
                            usePrimary = true;
                        }
                        this._bpcConfig.UsePrimaryColour = usePrimary;
                    }
                    if (this._bpcConfig.Orientation === "Horizontal" || this._typedConfig.SuppressBorder) {
                        this._bpcContainer.classList.add('widget__body-item--no-padding');
                    }
                    this._bpcComponent = new Widgets.ComponentButtonPalette(this._core, this._bpcContainer, this, this._bpcConfig, this._optionSelected);
                    this._bpcComponent.present();
                    this._core.OBHelper.LoadQueues(this._psTasksLoadedNotification);
                    this._core.OBHelper.LoadPseudoSystemTasks(this._queuesLoadedNotification);
                };
                this._queuesLoadedNotification = () => {
                    this._log.info("ActionPaletteInstanceClass._queuesLoadedNotification()");
                    this._queuesLoaded = true;
                    if (this._psTasksLoaded)
                        this._reportInstanceReady();
                };
                this._psTasksLoadedNotification = () => {
                    this._log.info("ActionPaletteInstanceClass._psTasksLoadedNotification()");
                    this._psTasksLoaded = true;
                    if (this._queuesLoaded)
                        this._reportInstanceReady();
                };
                this._reportInstanceReady = () => {
                    this._log.info("ActionPaletteInstanceClass._reportInstanceReady()");
                    this._type.instanceReady(this.getHandle());
                };
                this._callFailedHandler = (json) => {
                    this._log.info("ActionPaletteInstanceClass._callFailedHandler()");
                    let response = json;
                    if (this._busyModalSession) {
                        this._core.Helper.closeBusyModal(this._busyModalSession);
                        this._busyModalSession = null;
                    }
                    this.addError(response.Connection.Message);
                };
                this._callErrorHandler = (url, status, message) => {
                    this._log.info("ActionPaletteInstanceClass._callErrorHandler()");
                    if (this._busyModalSession) {
                        this._core.Helper.closeBusyModal(this._busyModalSession);
                        this._busyModalSession = null;
                    }
                    this.addError(message);
                };
                this._requestHitList = () => {
                    this._log.info("ActionPaletteInstanceClass._requestHitList()");
                    if (this._query) {
                        let requestSearch = this._core.OBHelper.compileFlexSearchFromQueryDef(this._query);
                        this._core.Loader.genericServiceCallWithData('/Documents.svc/rest/DocumentQuery', JSON.stringify(requestSearch), this._receivedHitList, {}, this._callErrorHandler, this._callFailedHandler);
                    }
                    else if (this._flexQuery) {
                        let requestSearch = this._core.OBHelper.flexDefinitionToRequest(this._flexQuery);
                        this._core.Loader.genericServiceCallWithData('/Documents.svc/rest/DocumentQuery', JSON.stringify(requestSearch), this._receivedHitList, {}, this._callErrorHandler, this._callFailedHandler);
                    }
                };
                this._receivedHitList = (response) => {
                    this._log.info("ActionPaletteInstanceClass._receivedHitList()");
                    if (response.hasOwnProperty('Documents') && response.Documents.length > 0) {
                        this._currentDocument = response.Documents[0];
                        this._displayTasks();
                    }
                    else {
                        console.warn("no documents received");
                        this.clearDocActions();
                    }
                };
                // Need to force overwrite nulls in triggers so we can check them smoothly later
                this._zeroTriggers = () => {
                    this._log.info("ActionPaletteInstanceClass._zeroTriggers()");
                    this._core.Functions.addDefaultsToTriggerEvents(this._refreshTriggers);
                    this._typedConfig.TaskOverrides.forEach(override => {
                        if (!override.hasOwnProperty('DisplayConditions') || (override.DisplayConditions == null))
                            override.DisplayConditions = [];
                        override.DisplayConditions.forEach(condition => {
                            if (!condition.hasOwnProperty('SwitchTriggers') || (condition.SwitchTriggers == null))
                                condition.SwitchTriggers = [];
                            this._core.Functions.addDefaultsToTriggerEvents(condition.SwitchTriggers);
                        });
                    });
                };
                this.clearDocActions = () => {
                    this._log.info("ActionPaletteInstanceClass.clearDocActions()");
                    this._currentQueue = null;
                    this._currentDocument = null;
                    this._displayTasks();
                };
                this._clearWvActions = () => {
                    this._log.info("ActionPaletteInstanceClass._clearWvActions()");
                    this._currentWvObject = null;
                    this._displayTasks();
                };
                this._displayTasks = () => __awaiter(this, void 0, void 0, function* () {
                    this._log.info("ActionPaletteInstanceClass._displayTasks()");
                    this._core.Functions.showElement(this._loader);
                    this._bpcComponent.displayOptions(yield this._compileTaskRecords(), this._displayedCallback);
                });
                // Used in case we want to completely vanish when not populated
                this._displayedCallback = (count) => {
                    this._log.info("ActionPaletteInstanceClass._displayedCallback()");
                    this._core.Functions.hideElement(this._loader);
                    if (this._cloakIfNoActions && !count)
                        this._core.Functions.hideElement(this._outerDiv);
                    else
                        this._core.Functions.showElement(this._outerDiv);
                };
                this._compileTaskRecords = () => __awaiter(this, void 0, void 0, function* () {
                    this._log.info("ActionPaletteInstanceClass._compileTaskRecords()");
                    // Clear down and reset internal overrides list
                    this._overrides = JSON.parse(JSON.stringify(this._typedConfig.TaskOverrides));
                    let options = [];
                    // Ad-hoc tasks
                    options.push(...this._compileAHTRecords(this._ahtInitialFilter()));
                    options.push(...this._compileDARecords(this._daInitialFilter()));
                    options.push(...this._compilePSTRecords(this._pstInitialFilter()));
                    options.push(...this._compileWVARecords(yield this._wvaInitialFilter()));
                    return options;
                });
                // Check at instance-level config to get list of tasks we might display
                this._ahtInitialFilter = () => {
                    this._log.info("ActionPaletteInstanceClass._ahtInitialFilter()");
                    let response = [];
                    // Let's see what we've got
                    let defaultVisibility = this._typedConfig.ShowAdHocTasks;
                    if (this._currentQueue && this._currentQueue.hasOwnProperty('Actions') && (this._currentQueue.Actions != null)) {
                        this._currentQueue.Actions.forEach(action => {
                            let exceptionDeclared = false;
                            this._typedConfig.ExceptAdHocTasks.forEach(exception => {
                                let chunks = exception.split('|');
                                if (chunks.length > 2) {
                                    if ((chunks[0] == this._currentQueue.Name) && (chunks[1] == this._currentQueue.LifeCycle.Name) && (chunks[2] == action.Name)) {
                                        exceptionDeclared = true;
                                    }
                                }
                            });
                            // Process exception result
                            if (defaultVisibility != exceptionDeclared)
                                response.push(action);
                        });
                    }
                    return response;
                };
                // Check at instance-level config to get list of tasks we might display
                this._daInitialFilter = () => {
                    var _a;
                    this._log.info("ActionPaletteInstanceClass._daInitialFilter()");
                    let response = [];
                    if (this._currentDocument) {
                        let actionRequest = new WPTNamespace.DocActions.DocActionRequest(this._currentDocument.ItemNum);
                        actionRequest.Document = this._currentDocument;
                        if (this._currentDocument.DocType)
                            actionRequest.DocumentType = this._currentDocument.DocType;
                        let allowedRequest = new WPTNamespace.DocActions.DocActionAllowedRequest();
                        if ((_a = this._currentDocument) === null || _a === void 0 ? void 0 : _a.DocType)
                            allowedRequest.DocumentType = this._currentDocument.DocType;
                        let allowedActions = this._core.DocumentActions.getAllowedActions(actionRequest, allowedRequest);
                        // Let's see what we've got
                        let defaultVisibility = this._typedConfig.ShowDocActions;
                        allowedActions.forEach(action => {
                            if (this._log.isTraceEnabled()) {
                                this._log.trace(`checking action '${action.Name}'`);
                            }
                            if (!action.Name.startsWith(WPTNamespace.DocActions.PSEUDO_SYS_TASK)) {
                                let exceptionDeclared = false;
                                if (this._typedConfig.ExceptDocActions.indexOf(action.Name) > -1)
                                    exceptionDeclared = true;
                                // Process exception result
                                if (defaultVisibility != exceptionDeclared)
                                    response.push(action);
                            }
                        }, this);
                    }
                    return response;
                };
                this._pstInitialFilter = () => {
                    this._log.info("ActionPaletteInstanceClass._pstInitialFilter()");
                    let response = [];
                    if (this._currentDocument) {
                        // Let's see what we've got
                        let defaultVisibility = this._typedConfig.ShowPseudoSystemTasks;
                        for (let taskId in this._core.OBHelper.PseudoSystemTaskMap) {
                            if (this._log.isTraceEnabled()) {
                                this._log.trace(`checking task '${taskId}'`);
                            }
                            let pst = this._core.OBHelper.PseudoSystemTaskMap[taskId];
                            // Filter by doc type before normal visibility processing
                            if ((pst.DocTypes.indexOf('*') > -1) || ((pst.DocTypes.indexOf(this._currentDocument.DocType.Name) > -1))) {
                                let exceptionDeclared = false;
                                if (this._typedConfig.ExceptPseudoSystemTasks.indexOf(pst.Identifier) > -1)
                                    exceptionDeclared = true;
                                // Process exception result
                                if (defaultVisibility != exceptionDeclared)
                                    response.push(pst);
                            }
                        }
                    }
                    return response;
                };
                // Check at instance-level config to get list of tasks we might display
                this._wvaInitialFilter = () => __awaiter(this, void 0, void 0, function* () {
                    this._log.info("ActionPaletteInstanceClass._wvaInitialFilter()");
                    let response = [];
                    // Let's see what we've got
                    let defaultVisibility = this._typedConfig.ShowWVActions;
                    if (this._currentWvObject) {
                        let actions = this._core.OBHelper.WorkViewActions.filter((wva) => { return wva.Application == this._currentWvObject.Class.Application.Name && wva.Class == this._currentWvObject.Class.Name; });
                        if (actions) {
                            let classConfig = yield this._core.Helper.getWvViewConfigForClass(this._viewConfigFile, this._currentWvObject.Class.Application.Name, this._currentWvObject.Class.Name);
                            actions.forEach(action => {
                                let exceptionDeclared = false;
                                // if we don't have a display name yet, look for one
                                if (!action.DisplayName && classConfig && classConfig.hasOwnProperty('Actions') && classConfig.Actions.length > 0) {
                                    let actionConfig = classConfig.Actions.find(act => act.Name == action.Name);
                                    if (actionConfig && actionConfig.hasOwnProperty('DisplayName') && actionConfig.DisplayName.length > 0) {
                                        action.DisplayName = this._core.Locale.getTranslation(actionConfig.DisplayName);
                                    }
                                }
                                this._typedConfig.ExceptWVActions.forEach(exception => {
                                    if (exception.Application == action.Application && exception.Class == action.Class && exception.Name == action.Name) {
                                        exceptionDeclared = true;
                                    }
                                });
                                // Process exception result
                                if (defaultVisibility != exceptionDeclared)
                                    response.push(action);
                            });
                        }
                    }
                    return response;
                });
                this._compileAHTRecords = (actions) => {
                    this._log.info("ActionPaletteInstanceClass._compileAHTRecords()");
                    let options = [];
                    actions.forEach(action => {
                        let identifier = `AHT:${action.ID}`;
                        let option = { Identifier: identifier, Label: action.Name, Hidden: false, Group: "Workflow Tasks" };
                        // Check for an override
                        let override = this._overrides.find(o => ((o.Type == 'AdHocTask')
                            && (o.Name == action.Name)
                            && (o.Queue == this._currentQueue.Name)
                            && (o.Lifecycle == this._currentQueue.LifeCycle.Name)));
                        if (override) {
                            if (this._log.isTraceEnabled()) {
                                this._log.trace(`found override for ${action.Name}`);
                            }
                            override.InternalIdentifier = identifier;
                            let label = (override.hasOwnProperty('Label') && override.Label) ? override.Label : '';
                            let show = (override.hasOwnProperty('VisibleByDefault') && (override.VisibleByDefault != null)) ? override.VisibleByDefault : true;
                            if (override.hasOwnProperty('DisplayConditions') && override.DisplayConditions) {
                                if (this._core.OBHelper.evaluateActionPaletteConditions(override, this._currentDocument)) {
                                    // We have one remaining active condition
                                    let condition = override.DisplayConditions[0];
                                    show = (condition.hasOwnProperty('InitialVisibility') && (condition.InitialVisibility != null)) ? condition.InitialVisibility : false;
                                    if (condition.hasOwnProperty('Label') && condition.Label)
                                        label = condition.Label;
                                }
                            }
                            option.Hidden = !show;
                            if (override.hasOwnProperty('Icon') && override.Icon)
                                option.Icon = override.Icon;
                            else
                                option.Icon = this._core.Helper.getButtonIcon({
                                    Type: "AdHocTask",
                                    Name: action.Name,
                                    Queue: this._currentQueue.Name,
                                    Lifecycle: this._currentQueue.LifeCycle.Name
                                });
                            if (label)
                                option.Label = this._core.Locale.getTranslation(label);
                        }
                        else {
                            if (this._log.isTraceEnabled()) {
                                this._log.trace(`no override for ${action.Name}`);
                            }
                            option.Icon = this._core.Helper.getButtonIcon({
                                Type: "AdHocTask",
                                Name: action.Name,
                                Queue: this._currentQueue.Name,
                                Lifecycle: this._currentQueue.LifeCycle.Name
                            });
                            option.Hidden = false;
                        }
                        options.push(option);
                    });
                    return options;
                };
                this._compileDARecords = (actions) => {
                    this._log.info("ActionPaletteInstanceClass._compileDARecords()");
                    // Check we are even displaying these
                    let options = [];
                    actions.forEach(action => {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace(`checking action '${action.Name}'`);
                        }
                        let identifier = `DA:${action.Name}`;
                        let option = { Identifier: identifier, Label: action.Label, Hidden: false, Group: "Document Actions" };
                        // Check for an override
                        let override = this._overrides.find(o => ((o.Type == 'DocAction') && (o.Name == action.Name)));
                        if (override) {
                            if (this._log.isTraceEnabled()) {
                                this._log.trace(`override found for '${action.Name}'`);
                            }
                            override.InternalIdentifier = identifier;
                            let show = (override.hasOwnProperty('VisibleByDefault') && (override.VisibleByDefault != null)) ? override.VisibleByDefault : true;
                            if (override.hasOwnProperty('DisplayConditions') && override.DisplayConditions) {
                                if (this._core.OBHelper.evaluateActionPaletteConditions(override, this._currentDocument)) {
                                    // We have one remaining active condition
                                    let condition = override.DisplayConditions[0];
                                    show = (condition.hasOwnProperty('InitialVisibility') && (condition.InitialVisibility != null)) ? condition.InitialVisibility : false;
                                }
                            }
                            option.Hidden = !show;
                            if (override.hasOwnProperty('Icon') && override.Icon)
                                option.Icon = override.Icon;
                            else
                                option.Icon = this._core.Helper.getButtonIcon({
                                    Type: "DocAction",
                                    Name: action.Name
                                });
                            if (override.hasOwnProperty('Label') && override.Label)
                                option.Label = this._core.Locale.getTranslation(override.Label);
                        }
                        else {
                            if (this._log.isTraceEnabled()) {
                                this._log.trace(`no override for ${action.Name}`);
                            }
                            option.Icon = this._core.Helper.getButtonIcon({
                                Type: "DocAction",
                                Name: action.Name
                            });
                            option.Hidden = false;
                        }
                        options.push(option);
                    });
                    return options;
                };
                this._compilePSTRecords = (tasks) => {
                    this._log.info("ActionPaletteInstanceClass._compilePSTRecords()");
                    let options = [];
                    tasks.forEach(task => {
                        let identifier = `PST:${task.Identifier}`;
                        let option = { Identifier: identifier, Label: task.Label, Hidden: false, Group: "System Tasks" };
                        // Check for an override
                        let override = this._overrides.find(o => ((o.Type == 'SysTask') && (o.Name == task.Identifier)));
                        if (override) {
                            if (this._log.isTraceEnabled()) {
                                this._log.trace(`found override for ${task.Identifier}`);
                            }
                            override.InternalIdentifier = identifier;
                            let label = (override.hasOwnProperty('Label') && override.Label) ? override.Label : '';
                            let show = (override.hasOwnProperty('VisibleByDefault') && (override.VisibleByDefault != null)) ? override.VisibleByDefault : true;
                            if (override.hasOwnProperty('DisplayConditions') && override.DisplayConditions) {
                                if (this._core.OBHelper.evaluateActionPaletteConditions(override, this._currentDocument)) {
                                    // We have one remaining active condition
                                    let condition = override.DisplayConditions[0];
                                    show = (condition.hasOwnProperty('InitialVisibility') && (condition.InitialVisibility != null)) ? condition.InitialVisibility : false;
                                    if (condition.hasOwnProperty('Label') && condition.Label)
                                        label = condition.Label;
                                }
                            }
                            option.Hidden = !show;
                            if (override.hasOwnProperty('Icon') && override.Icon)
                                option.Icon = override.Icon;
                            else
                                option.Icon = this._core.Helper.getButtonIcon({
                                    Type: "SysTask",
                                    Name: task.Identifier
                                });
                            if (label)
                                option.Label = this._core.Locale.getTranslation(label);
                        }
                        else {
                            if (this._log.isTraceEnabled()) {
                                this._log.trace(`no override for ${task.Identifier}`);
                            }
                            option.Icon = this._core.Helper.getButtonIcon({
                                Type: "SysTask",
                                Name: task.Identifier
                            });
                            option.Hidden = false;
                        }
                        options.push(option);
                    });
                    return options;
                };
                this._compileWVARecords = (actions) => {
                    this._log.info("ActionPaletteInstanceClass._compileWVARecords()");
                    let options = [];
                    actions.forEach(action => {
                        let identifier = `WVA:${action.Name}`;
                        let option = {
                            Identifier: identifier,
                            Label: action.DisplayName ? action.DisplayName : action.Name,
                            Hidden: false,
                            Group: "WorkView Actions"
                        };
                        // Check for an override
                        let override = this._overrides.find(o => ((o.Type == 'WvAction')
                            && (o.Name == action.Name)
                            && (o.Class == this._currentWvObject.Class.Name)
                            && (o.Application == this._currentWvObject.Class.Application.Name)));
                        if (override) {
                            if (this._log.isTraceEnabled()) {
                                this._log.trace(`found override for ${identifier}`);
                            }
                            override.InternalIdentifier = identifier;
                            let label = (override.hasOwnProperty('Label') && override.Label) ? override.Label : '';
                            let show = (override.hasOwnProperty('VisibleByDefault') && (override.VisibleByDefault != null)) ? override.VisibleByDefault : true;
                            if (override.hasOwnProperty('DisplayConditions') && override.DisplayConditions) {
                                if (this._core.OBHelper.evaluateActionPaletteConditions(override, null, this._currentWvObject)) {
                                    // We have one remaining active condition
                                    let condition = override.DisplayConditions[0];
                                    show = (condition.hasOwnProperty('InitialVisibility') && (condition.InitialVisibility != null)) ? condition.InitialVisibility : false;
                                    if (condition.hasOwnProperty('Label') && condition.Label)
                                        label = condition.Label;
                                }
                            }
                            option.Hidden = !show;
                            if (override.hasOwnProperty('Icon') && override.Icon)
                                option.Icon = override.Icon;
                            else
                                option.Icon = this._core.Helper.getButtonIcon({
                                    Type: "WvAction",
                                    Name: action.Name,
                                    Class: this._currentWvObject.Class.Name,
                                    Application: this._currentWvObject.Class.Application.Name
                                });
                            if (label)
                                option.Label = this._core.Locale.getTranslation(label);
                        }
                        else {
                            if (this._log.isTraceEnabled()) {
                                this._log.trace(`no override for ${identifier}`);
                            }
                            option.Icon = this._core.Helper.getButtonIcon({
                                Type: "WvAction",
                                Name: action.Name,
                                Class: this._currentWvObject.Class.Name,
                                Application: this._currentWvObject.Class.Application.Name
                            });
                            option.Hidden = false;
                        }
                        options.push(option);
                    });
                    return options;
                };
                this._optionSelected = (optionId) => {
                    this._log.info("ActionPaletteInstanceClass._optionSelected()");
                    // Need to split down to our appropriate action
                    let idChunks = optionId.split(':');
                    switch (idChunks[0]) {
                        case "AHT":
                            this._adHocTaskSelected(Number(idChunks[1]));
                            break;
                        case "DA":
                            this._docActionSelected(idChunks[1]);
                            break;
                        case "PST":
                            this._pseudoSystemTaskSelected(idChunks[1]);
                            break;
                        case "WVA":
                            this._wvActionSelected(idChunks[1]);
                            break;
                        default:
                            this.addError(`Attempt to execute unrecognised option type '${optionId}'`);
                    }
                };
                this._docActionSelected = (daId) => {
                    this._log.info("ActionPaletteInstanceClass._docActionSelected()");
                    let request = new WPTNamespace.DocActions.DocActionRequest(this._currentDocument.ItemNum);
                    request.Document = this._currentDocument;
                    // Maybe add more items here
                    this._core.DocumentActions.execute(daId, request);
                };
                this._adHocTaskSelected = (taskId) => {
                    this._log.info("ActionPaletteInstanceClass._adHocTaskSelected()");
                    this._currentComment = "";
                    this._currentPST = null;
                    this._currentAHT = this._currentQueue.Actions.find(action => action.ID == taskId);
                    this._core.OBHelper.ActionHelper.executeAction(this._currentAHT, this._currentDocument, this._executeAction);
                };
                this._pseudoSystemTaskSelected = (taskId) => {
                    this._log.info("ActionPaletteInstanceClass._pseudoSystemTaskSelected()");
                    this._currentComment = "";
                    this._currentAHT = null;
                    this._currentPST = this._core.OBHelper.PseudoSystemTaskMap[taskId];
                    this._core.OBHelper.ActionHelper.executeAction(this._currentPST.ActionInfo, this._currentDocument, this._executeAction);
                };
                this._executeAction = (comment) => {
                    this._log.info("ActionPaletteInstanceClass._executeAction()");
                    this._currentComment = comment;
                    if (this._currentAHT != null)
                        this._executeAdHocTask();
                    else
                        this._executePseudoSystemTask();
                };
                this._executeAdHocTask = () => {
                    this._log.info("ActionPaletteInstanceClass._executeAdHocTask()");
                    let request = {
                        Action: this._currentAHT.Name,
                        Comment: this._currentComment,
                        LifeCycle: this._currentQueue.LifeCycle.Name,
                        Queue: this._currentQueue.Name
                    };
                    if (this._showBusyModal) {
                        let modalSession = 'adhoc-task-' + performance.now();
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("created modal session: " + modalSession);
                        }
                        if (this._core.Helper.presentBusyModal(WPTNamespace.ModalType.FIRST, modalSession, "STR_WPT_PROCESSING")) {
                            this._busyModalSession = modalSession;
                        }
                    }
                    this._core.Loader.genericServiceCallWithData(`/Workflow.svc/rest/ProcessAction/${this._currentDocument.ItemNum.toString()}`, JSON.stringify(request), this._adHocTaskComplete.bind(this, this._currentAHT.ID, this._currentDocument), {}, this._callErrorHandler, this._callFailedHandler);
                    // Clear action
                    this._currentAHT = null;
                    this._currentComment = "";
                    this._currentDocument = null;
                };
                this._adHocTaskComplete = (actionId, doc, response) => {
                    this._log.info("ActionPaletteInstanceClass._adHocTaskComplete()");
                    if (this._busyModalSession) {
                        let modal = this._core.getModal(this._busyModalSession);
                        let ap = this;
                        modal.JQ.one('hidden.bs.modal', function () {
                            ap._displayTaskMessages(response);
                        });
                        this._core.Helper.closeBusyModal(this._busyModalSession);
                        this._busyModalSession = null;
                    }
                    else
                        this._displayTaskMessages(response);
                    let config = this._config;
                    // Need to refreash the view - documents may have changed or moved out of the queue
                    let navEvent = new WPTNamespace.Navigation.ActivationContext(this, WPTNamespace.Navigation.LayoutActivationType.WORKFLOW_ACTION_FIRED);
                    navEvent.ActivationID = actionId;
                    navEvent.AdditionalContext = { "Document": doc };
                    let targetLayoutName = null;
                    let currentConditional = null;
                    if (config.hasOwnProperty('ConditionalLaunchLayout') && config.ConditionalLaunchLayout.length > 0) {
                        for (let i = 0; i < config.ConditionalLaunchLayout.length; i++) {
                            if (this._core.Context.evaluateSelectionCriteria(config.ConditionalLaunchLayout[i].Criteria, doc, null, navEvent)) {
                                currentConditional = config.ConditionalLaunchLayout[i];
                                if (this._log.isTraceEnabled()) {
                                    this._log.trace(`Conditional launch layout set to ${currentConditional.LaunchLayout}`);
                                }
                                break;
                            }
                        }
                    }
                    if (currentConditional && currentConditional.LaunchLayout.length > 0) {
                        if (currentConditional.LaunchLayout == "[[CURRENT]]")
                            targetLayoutName = this._currentLayout;
                        else
                            targetLayoutName = currentConditional.LaunchLayout;
                    }
                    else {
                        // Set default layout, but check if we've had an alternative requested against the instance
                        targetLayoutName = "Workflow";
                        if (config.hasOwnProperty("LaunchLayout") && config.LaunchLayout) {
                            if (config.LaunchLayout == "[[CURRENT]]")
                                targetLayoutName = this._currentLayout;
                            else
                                targetLayoutName = config.LaunchLayout;
                        }
                    }
                    navEvent.Layout = targetLayoutName;
                    this._core.Navigation.Details.requestActivation(navEvent);
                };
                this._executePseudoSystemTask = () => {
                    this._log.info("ActionPaletteInstanceClass._executePseudoSystemTask()");
                    let request = {
                        TaskIdentifier: this._currentPST.Identifier,
                        Comment: this._currentComment
                    };
                    if (this._showBusyModal) {
                        let modalSession = 'system-task-' + performance.now();
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("created modal session: " + modalSession);
                        }
                        if (this._core.Helper.presentBusyModal(WPTNamespace.ModalType.FIRST, modalSession, "STR_WPT_PROCESSING")) {
                            this._busyModalSession = modalSession;
                        }
                    }
                    this._core.Loader.genericServiceCallWithData(`/Workflow.svc/rest/ExecutePseudoSystemTask/${this._currentDocument.ItemNum.toString()}`, JSON.stringify(request), this._pseudoSystemTaskTaskComplete.bind(this, this._currentPST.Identifier, this._currentDocument), {}, this._callErrorHandler, this._callFailedHandler);
                    // Clear action
                    this._currentPST = null;
                    this._currentComment = "";
                    this._currentDocument = null;
                };
                this._pseudoSystemTaskTaskComplete = (taskId, doc, response) => {
                    this._log.info("ActionPaletteInstanceClass._pseudoSystemTaskTaskComplete()");
                    if (this._busyModalSession) {
                        let modal = this._core.getModal(this._busyModalSession);
                        let ap = this;
                        modal.JQ.one('hidden.bs.modal', function () {
                            ap._displayTaskMessages(response);
                        });
                        this._core.Helper.closeBusyModal(this._busyModalSession);
                        this._busyModalSession = null;
                    }
                    else
                        this._displayTaskMessages(response);
                    let config = this._config;
                    // May need to refreash the view - documents may have changed or moved out of the queue
                    let navEvent = new WPTNamespace.Navigation.ActivationContext(this, WPTNamespace.Navigation.LayoutActivationType.WORKFLOW_PSEUDO_SYSTASK);
                    navEvent.ActivationID = 0;
                    navEvent.PrimaryContext = this._core.OBHelper.PseudoSystemTaskMap[taskId];
                    navEvent.AdditionalContext = { "Document": doc };
                    let targetLayoutName = null;
                    let currentConditional = null;
                    if (config.hasOwnProperty('ConditionalLaunchLayout') && config.ConditionalLaunchLayout.length > 0) {
                        for (let i = 0; i < config.ConditionalLaunchLayout.length; i++) {
                            if (this._core.Context.evaluateSelectionCriteria(config.ConditionalLaunchLayout[i].Criteria, doc, null, navEvent)) {
                                currentConditional = config.ConditionalLaunchLayout[i];
                                if (this._log.isTraceEnabled()) {
                                    this._log.trace(`Conditional launch layout set to ${currentConditional.LaunchLayout}`);
                                }
                                break;
                            }
                        }
                    }
                    if (currentConditional && currentConditional.LaunchLayout.length > 0) {
                        if (currentConditional.LaunchLayout == "[[CURRENT]]")
                            targetLayoutName = this._currentLayout;
                        else
                            targetLayoutName = currentConditional.LaunchLayout;
                    }
                    else {
                        // Set default layout, but check if we've had an alternative requested against the instance
                        targetLayoutName = this._currentLayout;
                        if (config.hasOwnProperty("LaunchLayout") && config.LaunchLayout) {
                            if (config.LaunchLayout == "[[CURRENT]]")
                                targetLayoutName = this._currentLayout;
                            else
                                targetLayoutName = config.LaunchLayout;
                        }
                    }
                    navEvent.Layout = targetLayoutName;
                    this._core.Navigation.Details.requestActivation(navEvent);
                };
                this._displayTaskMessages = (response) => {
                    this._log.info("ActionPaletteInstanceClass._displayTaskMessages()");
                    // Set up our data
                    let messages = [];
                    let errors = false;
                    // Assemble message list
                    if (response.hasOwnProperty('ErrorMessages') && (response.ErrorMessages != null) && (response.ErrorMessages.length > 0)) {
                        messages.push(...response.ErrorMessages);
                        errors = true;
                    }
                    if (response.hasOwnProperty('Messages') && (response.Messages != null) && (response.Messages.length > 0))
                        messages.push(...response.Messages);
                    // Jump out if nothing to disaplay
                    if (messages.length == 0)
                        return;
                    // Compile into a useful string
                    let compiled = '';
                    if (messages.length == 1) {
                        compiled = this._core.Locale.getTranslation(messages[0]);
                    }
                    else {
                        compiled = '<ul>';
                        messages.forEach(msg => { compiled = compiled + `<li>${this._core.Locale.getTranslation(msg)}</li>`; });
                        compiled = compiled + '</ul>';
                    }
                    if (errors)
                        this._core.Helper.presentWarningModal(compiled);
                    else
                        this._core.Helper.presentMessageModal(WPTNamespace.ModalType.FIRST, compiled);
                };
                this._wvActionSelected = (wvaId) => {
                    this._log.info("ActionPaletteInstanceClass._wvActionSelected()");
                    this._currentWVA = {
                        Action: wvaId,
                        Application: this._currentWvObject.Class.Application.Name,
                        Class: this._currentWvObject.Class.Name,
                        ObjectId: this._currentWvObject.Id
                    };
                    if (this._showBusyModal) {
                        let modalSession = 'wv-action-' + performance.now();
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("created modal session: " + modalSession);
                        }
                        if (this._core.Helper.presentBusyModal(WPTNamespace.ModalType.FIRST, modalSession, "STR_WPT_PROCESSING")) {
                            this._busyModalSession = modalSession;
                        }
                    }
                    this._core.Loader.genericServiceCallWithData('/WorkView.svc/rest/ExecuteAction', JSON.stringify(this._currentWVA), this._wvActionComplete.bind(this, this._currentWVA), {}, this._callErrorHandler, this._callFailedHandler);
                    // Clear action
                    this._currentWVA = null;
                };
                this._wvActionComplete = (wvAction) => {
                    this._log.info("ActionPaletteInstanceClass._wvActionComplete()");
                    if (this._busyModalSession) {
                        this._core.Helper.closeBusyModal(this._busyModalSession);
                        this._busyModalSession = null;
                    }
                    let config = this._config;
                    // May need to refresh the view - objects may have changed
                    let navEvent = new WPTNamespace.Navigation.ActivationContext(this, WPTNamespace.Navigation.LayoutActivationType.WV_ACTION_FIRED);
                    navEvent.ActivationID = wvAction.ObjectId;
                    navEvent.PrimaryContext = wvAction;
                    let targetLayoutName = null;
                    let currentConditional = null;
                    if (config.hasOwnProperty('ConditionalLaunchLayout') && config.ConditionalLaunchLayout.length > 0) {
                        for (let i = 0; i < config.ConditionalLaunchLayout.length; i++) {
                            if (this._core.Context.evaluateSelectionCriteria(config.ConditionalLaunchLayout[i].Criteria, null, this._currentWvObject, navEvent)) {
                                currentConditional = config.ConditionalLaunchLayout[i];
                                if (this._log.isTraceEnabled()) {
                                    this._log.trace(`Conditional launch layout set to ${currentConditional.LaunchLayout}`);
                                }
                                break;
                            }
                        }
                    }
                    if (currentConditional && currentConditional.LaunchLayout.length > 0) {
                        if (currentConditional.LaunchLayout == "[[CURRENT]]")
                            targetLayoutName = this._currentLayout;
                        else
                            targetLayoutName = currentConditional.LaunchLayout;
                    }
                    else {
                        // Set default layout, but check if we've had an alternative requested against the instance
                        targetLayoutName = this._currentLayout;
                        if (config.hasOwnProperty("LaunchLayout") && config.LaunchLayout) {
                            if (config.LaunchLayout == "[[CURRENT]]")
                                targetLayoutName = this._currentLayout;
                            else
                                targetLayoutName = config.LaunchLayout;
                        }
                    }
                    navEvent.Layout = targetLayoutName;
                    this._core.Navigation.Details.requestActivation(navEvent);
                };
                // Included for compatability with WFA widget.
                this.queueSelected = (queue) => {
                    this._log.info("ActionPaletteInstanceClass.queueSelected()");
                    if ((queue != null) && (this._currentQueue != null) && (queue.Id == this._currentQueue.Id)) {
                        return;
                    }
                    else {
                        this._currentQueue = queue;
                        this._currentDocument = null;
                    }
                };
                this.documentSelected = (doc) => {
                    this._log.info("ActionPaletteInstanceClass.documentSelected()");
                    this._currentDocument = doc;
                    if (this._currentDocument == null) {
                        //this._clearActionList();
                    }
                    else {
                        this._displayTasks();
                    }
                };
                this._setQueue = (queueId) => {
                    this._log.info("ActionPaletteInstanceClass._setQueue()");
                    if (this._core.OBHelper.QueuesLoaded) {
                        this._currentQueue = this._core.OBHelper.Queues.find(q => q.Id == queueId);
                        this._displayTasks();
                    }
                    else {
                        this._core.OBHelper.LoadQueues(this._setQueue.bind(this, queueId));
                    }
                };
                this._processTriggerEvents = (context) => {
                    this._log.info("ActionPaletteInstanceClass._processTriggerEvents()");
                    if (this._log.isTraceEnabled()) {
                        this._log.trace(`_processTriggerEvents activation type: ${context.ActivationType}`);
                    }
                    if (this._refreshTriggers.length > 0) {
                        // Loop with iterator so we can escape when necessary
                        for (let i = 0; i < this._refreshTriggers.length; i++) {
                            let trigger = this._refreshTriggers[i];
                            if (this._core.Functions.triggerEventMatches(trigger, context)) {
                                if (this._query || this._flexQuery)
                                    this._requestHitList();
                                else
                                    this._displayTasks();
                                // Only trigger once
                                return;
                            }
                            else {
                                continue;
                            }
                        }
                    }
                    this._overrides.forEach(override => {
                        if (override.DisplayConditions.length > 0) {
                            if (override.DisplayConditions[0].SwitchTriggers.length > 0) {
                                for (let i = 0; i < override.DisplayConditions[0].SwitchTriggers.length; i++) {
                                    let trigger = override.DisplayConditions[0].SwitchTriggers[i];
                                    if (this._log.isTraceEnabled()) {
                                        this._log.trace(`attempting match for ${context.ActivationType}`);
                                    }
                                    if (this._core.Functions.triggerEventMatches(trigger, context)) {
                                        if (this._log.isTraceEnabled()) {
                                            this._log.trace(`applying valid trigger for ${context.ActivationType}`);
                                        }
                                        if (override.DisplayConditions[0].InitialVisibility)
                                            this._bpcComponent.hideOption(override.InternalIdentifier);
                                        else
                                            this._bpcComponent.showOption(override.InternalIdentifier);
                                        if (this._cloakIfNoActions && !this._bpcComponent.VisibleCount)
                                            this._core.Functions.hideElement(this._outerDiv);
                                        else
                                            this._core.Functions.showElement(this._outerDiv);
                                        // Only trigger once
                                        return;
                                    }
                                    else {
                                        continue;
                                    }
                                }
                            }
                        }
                    });
                };
                this._log = this._core.Logging.getLogger(LOG_CATEGORY);
                this._log.info("ActionPaletteInstanceClass::constructor");
                this._instanceSelector = config.PlaceHolder;
                this._container = document.querySelector(this._instanceSelector);
                this._typedConfig = config;
                let appConfig = this._core.Config.getApplicationConfig();
                if (appConfig.hasOwnProperty('WorkViewViewConfiguration') && appConfig.WorkViewViewConfiguration) {
                    this._viewConfigFile = appConfig.WorkViewViewConfiguration;
                }
            }
            activate(context) {
                this._log.info("ActionPaletteInstanceClass.activate()");
                // Don't get stuck in a loop!
                if (!this._activationSourceValid(context))
                    return;
                let processTriggers = true;
                switch (context.ActivationType) {
                    case WPTNamespace.Navigation.LayoutActivationType.DOCUMENT_SELECTED:
                        let docSlots = this._reactToDocSlots.filter(slot => (context.Slots.indexOf(slot) > -1));
                        if (docSlots.length > 0) {
                            // only remember slots we react to
                            this._lastReactedDocSlots = docSlots;
                            processTriggers = false;
                            this._currentQueue = null;
                            if (this._query || this._flexQuery) {
                                this._requestHitList();
                            }
                            else {
                                let slotDoc = this._core.Context.getDocumentFromSlot(this._lastReactedDocSlots[0]);
                                if (slotDoc)
                                    this._currentDocument = slotDoc;
                                if (context.AdditionalContext && context.AdditionalContext.hasOwnProperty('SourceQueueRecord')) {
                                    this._currentQueue = context.AdditionalContext.SourceQueueRecord;
                                    this._displayTasks();
                                }
                                else if (context.AdditionalContext && context.AdditionalContext.hasOwnProperty('SourceQueueID'))
                                    this._setQueue(context.AdditionalContext.SourceQueueID);
                                else
                                    this._displayTasks();
                            }
                        }
                        else if ((this._reactToDocSlots.length > 0) && this._clearOnNonResponderDoc) {
                            this.clearDocActions();
                        }
                        break;
                    case WPTNamespace.Navigation.LayoutActivationType.DOCUMENT_DESELECTED:
                        let docIntersection = this._lastReactedDocSlots.filter(slot => (context.Slots.indexOf(slot) > -1));
                        if (docIntersection.length > 0) {
                            this._lastReactedDocSlots = [];
                            this.clearDocActions();
                        }
                        break;
                    case WPTNamespace.Navigation.LayoutActivationType.WV_OBJECT_SELECTED:
                        let wvSlots = this._reactToWvObjSlots.filter(slot => (context.Slots.indexOf(slot) > -1));
                        if (wvSlots.length > 0) {
                            // only remember slots we react to
                            this._lastReactedWvObjSlots = wvSlots;
                            processTriggers = false;
                            let slotWvObject = this._core.Context.getWvObjectFromSlot(this._lastReactedWvObjSlots[0]);
                            if (slotWvObject)
                                this._currentWvObject = slotWvObject;
                            this._core.OBHelper.LoadWorkViewOverview(this._displayTasks);
                        }
                        break;
                    case WPTNamespace.Navigation.LayoutActivationType.WV_OBJECT_DESELECTED:
                        let wvIntersection = this._lastReactedWvObjSlots.filter(slot => (context.Slots.indexOf(slot) > -1));
                        if (wvIntersection.length > 0) {
                            this._lastReactedWvObjSlots = [];
                            this._clearWvActions();
                        }
                        break;
                    default:
                        break;
                }
                // Process triggers after the main line in case we want to force a refresh on a DOCUMENT or RELATED
                if (processTriggers)
                    this._processTriggerEvents(context);
            }
        }
        ActionPaletteInstanceClass.HtmlData = null;
        Widgets.ActionPaletteInstanceClass = ActionPaletteInstanceClass;
    })(Widgets = WPTNamespace.Widgets || (WPTNamespace.Widgets = {}));
})(WPTNamespace || (WPTNamespace = {}));
